<template>
  <Breadcrumbs title="" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header" v-if="this.eventDetails.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-radius: 0.6em;border: none;padding: 0;background: transparent;"
                  :src="this.eventDetails.coverurl"
                  alt="Image description"
                />
              </figure>
            </div>
             <h5>{{ this.eventDetails.title }}</h5>
           <!-- VDO{{ this.cart_store_package.cart_videos }} -->
                <p style="font-size: small; line-height: 1.2;">
                  <i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ this.eventDetails.event_date_text }}<br />
                  &nbsp;<i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp; {{ this.eventDetails.province }}<br />
                  {{ this.currentLanguage === 'en' ? "Open search at" : "ช่วงเวลาที่เปิดขาย" }}: {{ this.eventDetails.on_sale_start }}
                  <span>
                    &nbsp;{{ this.currentLanguage === 'en' ? "To" : "ถึงวันที่" }}: {{ this.eventDetails.on_sale_end }}
                    <template v-if="this.eventDetails.day_diff <= 10 && this.eventDetails.day_diff > 0">
                      <font style="color: red">
                        ({{ this.currentLanguage === 'en' ? "There is still time left to store photo" : "คงเหลือเวลาจัดเก็บรูปอีก" }} {{ this.eventDetails.day_diff }} {{ this.currentLanguage === 'en' ? "days" : "วัน" }})
                      </font>
                    </template>
                  </span>
                </p>            
            <p>
              <span style="padding: 3px;margin: 3px;"
                v-for="(_package, index) in this.eventPackageHybridPackage"
                :key="index"
                class="btn btn-outline-info btn-sm"><b>&nbsp;{{this.currentLanguage ==='en'?_package.name_en:_package.name}}</b>
              </span>
            </p>
            
             <!-- package event -->
            <a :href="'../'+this.$route.params.event_id">
            <button v-if="this.eventDetails.is_mhao_hybrid_package === 'Y' " class="btn btn btn-primary" style="width: 100%" >{{this.currentLanguage ==='en'?"Get unlimited package click":"ซื้อรูปภาพและวีดีโอราคาเหมาๆ คลิ๊กที่นี่"}}</button></a>
          
            <!-- hb event -->
            <a :href="this.$route.params.event_id+'/wholesale'">
            <button v-if="this.eventDetails.is_hybrid === 'Y'" class="btn btn-lg btn-primary" style="width: 100%" >{{this.currentLanguage ==='en'?"Get unlimited package click":"ซื้อโปรเหมาๆ ราคาพิเศษ คลิ๊กที่นี่"}}</button></a>
            <!-- hb event -->
             <!-- stage event -->
            <a :href="this.$route.params.event_id+'/manual'">
            <button v-if="this.eventDetails.is_event_stage	 === 'Y'" class="btn btn-lg btn-primary" style="width: 100%" >{{this.currentLanguage ==='en'?"Manual find images":"ค้นหารูปภาพด้วยตนเอง"}}</button></a>
            <p style="font-size: small;" v-if="this.eventDetails.is_mhao_hybrid_package === 'Y'">
              <template v-if="this.currentLanguage === 'en'">
              &nbsp; *Package purchase allows multiple searches, multiple people can purchase together at the package price.<br>
              </template>
              <template v-else>
              &nbsp; *ซื้อแบบแพ็คเกจ สามารถค้นหาหลายๆครั้ง มาหลายคน ก็ซื้อรวมกันได้ในราคาแพ็คเกจ  <br>
              </template>
            </p>

            <p style="font-size: small;" v-if="this.eventDetails.is_event_stage === 'Y'">
              <template v-if="this.currentLanguage === 'en'">
              <b>Recommendation: Find more photos (no additional cost)</b><br>
              &nbsp; For searching additional photos, such as underwater photos or photos without visible faces, after you have purchased the unlimited package:<br>
              &nbsp; <b>1. Initial search:</b> Upload your face photo to the system to search for images, select the unlimited package, fill in all information, and complete the payment.<br>
              &nbsp; <b>2. Search for more photos:</b> Click the "Manual find images" button, select the event location, and add the desired photos to your cart. Then create an order for "Request additional photos after unlimited purchase".<br>
              &nbsp; <b>3. Notify admin:</b> Notify the admin for approval. Once approved, you can download the additional photos immediately.
              </template>
              <template v-else>
              <b>คำแนะนำ: ค้นหารูปภาพเพิ่มเติม (ไม่เสียค่าใช้จ่าย)</b><br>  
              &nbsp; สำหรับการค้นหารูปภาพเพิ่มเติม เช่น ภาพใต้น้ำ หรือภาพที่ไม่เห็นใบหน้า หลังจากที่คุณได้สั่งซื้อแพ็กเกจเหมาๆ รูปภาพไปแล้ว:<br>
              &nbsp; <b>1. ค้นหาภาพเริ่มต้น:</b> อัปโหลดรูปใบหน้าของคุณเข้าระบบเพื่อค้นหาภาพ และเลือกโปรเหมาๆ กรอกข้อมูลให้ครบถ้วนและชำระเงินเรียบร้อย<br>
              &nbsp; <b>2. ค้นหาภาพเพิ่มเติม:</b> กดปุ่ม "ค้นหารูปภาพด้วยตนเอง" เลือกสถานที่แข่งขัน และเพิ่มรูปภาพที่คุณต้องการลงในตะกร้า จากนั้นสร้างคำสั่งซื้อ "ขอรูปเพิ่มเติมหลังจากเหมาไปแล้ว"<br>
              &nbsp; <b>3. แจ้งแอดมิน:</b> แจ้งแอดมินเพื่อขออนุมัติ เมื่อได้รับการอนุมัติแล้ว คุณสามารถดาวน์โหลดรูปภาพเพิ่มเติมได้ทันที
              </template>
            </p>
            <!-- stage event -->

            <!-- manual event -->
             <a :href="this.$route.params.event_id+'/manual'">
            <button v-if="this.eventDetails.is_event_manual	 === 'Y'" class="btn btn-lg d-flex align-items-center justify-content-center gap-2" style="width: 100%; background: linear-gradient(135deg, #6c757d, #495057); border: none; border-radius: 10px; font-weight: 600; color: white; box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3); transition: all 0.3s ease;" 
                   onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 20px rgba(108, 117, 125, 0.4)'; this.style.background='linear-gradient(135deg, #5a6268, #343a40)'" 
                   onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 15px rgba(108, 117, 125, 0.3)'; this.style.background='linear-gradient(135deg, #6c757d, #495057)'">
              <vue-feather type="users" size="20"></vue-feather>{{this.currentLanguage ==='en'?"Search photos manually":"ค้นหารูปภาพด้วยตนเอง"}}</button>
            </a>
             <!-- end manual event -->
              <ManualSearchNote 
              v-if="this.eventDetails.is_event_manual === 'Y'" 
              :currentLanguage="this.currentLanguage" 
            />
            <p></p>
            <div class="row">
              <!-- <div class="col-sm-1"></div> -->
              <div class="col-sm-12" v-if="this.eventDetails.can_sale === 'Y'">
                <div v-if="this.eventDetails.close_sale === 'N'">
                <label for="fileInput" class="drop-container" id="dropcontainer" @change="faceSearch" >
                  <span class="drop-title" v-if="isSearching !== 'true'"><vue-feather type="image" size="36" class="text-top" ></vue-feather><br>
                   <span style="font-size: small;"> {{this.currentLanguage ==='en'?"upload your face to find images":"อัปโหลดภาพใบหน้าเพื่อค้นหา..."}}</span></span >
                  
                  <span class="drop-title" v-if="isSearching === 'true' && !isUploading" ><img style="align-items: center; width: 30px"  src="../../assets/images/running_loading.svg" />
                    <!-- <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> -->
                    {{this.currentLanguage ==='en'?"Searching...":"กำลังค้นหา..."}}</span>
                  
                  <span class="drop-title" v-if="isUploading" >
                    {{this.currentLanguage ==='en'?"Uploading...":"กำลังอัปโหลด..."}}<br>
                    <div class="progress-container">
                      <div class="progress-bar" :style="{width: uploadProgress + '%'}"></div>
                    </div>
                    <small>{{ uploadProgress }}%</small>
                  </span>
                  <input class="btn btn-square btn-outline-info btn-lg" type="file" id="fileInput" accept="image/png, image/jpeg" required />
                </label>
              </div>

              <div  v-if="this.eventDetails.close_sale === 'Y'">
                <div class="d-flex justify-content-center">
                  <vue-feather type="clock" size="17"></vue-feather>
                </div>
                <div class="d-flex justify-content-center">
                  {{this.currentLanguage ==='en'?"End of Sale":"กิจกรรมนี้ ปิดการขายแล้ว"}}
                </div>
              </div>
              </div>

              
              <div class="col-sm-12" v-if="this.eventDetails.can_sale === 'N'">
                <div class="d-flex justify-content-center">
                  <h6 style="color: red;">
                  {{this.currentLanguage ==='en'?"The event is not open for search yet":"กิจกรรมนี้ ยังไม่พร้อมให้ค้นหา"}} 
                  </h6>
                </div>
                <label for="fileInput" class="drop-container" id="dropcontainer" style="cursor: not-allowed; opacity: 0.8; pointer-events: none; background-color: #f5f5f5;" >
                  <span style="margin-top: 3px;" class="drop-title">
                    <span style="font-size: 13px; color: #999">กำลังนำรูปภาพเข้าระบบ...</span> <br>
                   <span style="font-size: small; color: #999"><vue-feather type="image" size="17" class="text-top" style="opacity: 0.9;"></vue-feather> {{this.currentLanguage ==='en'?"upload your face to find images":"เปิดให้อัปโหลด ภาพใบหน้าเพื่อค้นหา..."}}<br> <span style="color: black;">{{ this.eventDetails.on_sale_start_txt }}</span></span></span >
                </label>
                <input class="btn btn-square btn-outline-info btn-lg" type="file" id="fileInput" accept="image/png, image/jpeg" disabled />

               <hr>
                <div class="d-flex justify-content-center">
                   {{this.currentLanguage ==='en'?"Alternatively, you can follow us at":"หรือสามารถมารถติดตามพวกเราได้ที่"}}
                </div>
                <div class="d-flex justify-content-center">
                  <a :href="fbUrl" target="_blank"><h5><img style="align-items: center; height: 40px" src="../../assets/images/running/facebook-icon.png" />  {{fbName}}</h5></a>
                </div>
              </div>
              <!-- <div class="col-sm-1"></div> -->
            </div>
          </div>
          
          <div class="card-header" v-if="!this.eventDetails.title">
            <div class="d-flex justify-content-center" >
                <img style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
            </div>
            <div class="d-flex justify-content-center">
              {{this.currentLanguage ==='en'?"loading...":"กำลังโหลดข้อมูลกิจกรรม..."}}
            </div>
          </div>
        </div>
        <!-- <div class="row"> &nbsp;</div> -->
        <div class="card" v-if="this.is_show_image_search === 'Y'">
          <div v-if="cart_store_package.cart_images.length > 0 || (cart_store_package.cart_videos.length > 0 && this.eventDetails.is_enable_vdo==='Y')" class="card-header">
            
            <button
              style="width: 100%"
              v-if="
                this.eventDetails.is_free_download === 'Y' &&
                this.images_download_all.length > 0
              "
              type="button"
              class="btn btn-primary"
              @click.prevent="load_images()"
            >
            {{this.currentLanguage ==='en'?"Download all photos":"ดาวน์โหลดรูปทั้งหมด"}}
            </button>
            <p style="text-align: center">
              {{this.currentLanguage ==='en'?"Found matching face ":"ค้นพบภาพของท่านจำนวน "}}<b style="color: red;"> {{ cart_store_package.cart_images.length }}</b> {{this.currentLanguage ==='en'?"items":"ใบ"}}
              <span v-if="this.eventDetails.is_enable_vdo==='Y' && cart_store_package.cart_videos.length">{{this.currentLanguage ==='en'?", Found video matching ":"และค้นพบวีดีโอจำนวน "}}<b style="color: red;"> {{ cart_store_package.cart_videos.length }}</b> {{this.currentLanguage ==='en'?"items":"วิดีโอ"}}</span>
            </p>
            <button  v-if=" cart_store_package.cart_images.length > 0 && this.eventDetails.is_free_download_keep_contract === 'Y' &&  this.eventDetails.is_free_download_keep_contract_spacial === 'N' " class="btn btn-lg btn-primary"
              @click="
                cart_store_package.addToCartALLImage(
                  cart_store_package.cart_images,
                  'N',
                  0
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"Add all to cart":"เลือกรูปทั้งหมดใส่ตะกร้า"}}
            </button>
            <button  v-if=" cart_store_package.cart_images.length > 0 && this.eventDetails.is_free_download_keep_contract === 'Y' &&  this.eventDetails.is_free_download_keep_contract_spacial === 'Y' " class="btn btn-lg btn-primary"
              @click="addToCartALLImageAndCreateOrderEventDetail() " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"Prepare to download":"เลือกรูปทั้งหมด สำหรับเตรียมดาวน์โหลดรูปภาพ"}}
            </button>
            <button  v-if=" cart_store_package.cart_images.length > 0 && this.eventDetails.is_mhao === 'Y' && this.eventDetails.is_enable_vdo==='N' " class="btn btn-lg btn-primary"
              @click="
                cart_store_package.addToCartALLImage(
                  cart_store_package.cart_images,
                  this.eventDetails.is_mhao,
                  this.eventDetails.mhao_price,
                  this.eventDetails.mhao_price_vdo,
                  this.eventDetails.mhao_price_both,
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"Get Unlimited package " + this.eventDetails.mhao_price + " THB":"เลือกเหมาๆสุดคุ้ม ทุกใบ " + this.eventDetails.mhao_price + " บาท"}}
              ( {{this.currentLanguage ==='en'?"Avg":"เฉลี่ย"}} {{ this.imgs_avg_price }} ) {{this.currentLanguage ==='en'?"per items":"ต่อใบ"}}
            </button>

            <!-- video -->
            <span v-if="this.eventDetails.is_enable_vdo==='Y'">
              <button  v-if="cart_store_package.cart_images.length > 0 && cart_store_package.cart_videos.length > 0 && this.eventDetails.is_mhao === 'Y' && this.currentFilter ==='both' " class="btn btn-lg btn-primary"
              @click="
                cart_store_package.addToCartALLImage(
                  cart_store_package.cart_images,
                  this.eventDetails.is_mhao,
                  this.eventDetails.mhao_price,
                  this.eventDetails.mhao_price_vdo,
                  this.eventDetails.mhao_price_both,
                  this.currentFilter
                ),cart_store_package.addToCartALLImage_videos(
                  cart_store_package.cart_videos,
                  this.eventDetails.is_mhao,
                  this.eventDetails.mhao_price,
                  this.eventDetails.mhao_price_vdo,
                  this.eventDetails.mhao_price_both,
                  this.currentFilter
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"PHOTO+VIDEO " + this.eventDetails.mhao_price_both + " THB":"เหมาๆรูปภาพ+วิดีโอ " + this.eventDetails.mhao_price_both + " บาท"}}
            </button>
              <button  v-if=" cart_store_package.cart_images.length > 0 && this.eventDetails.is_mhao === 'Y' && this.currentFilter ==='photo' " class="btn btn-lg btn-primary"
              @click="
                cart_store_package.addToCartALLImage(
                  cart_store_package.cart_images,
                  this.eventDetails.is_mhao,
                  this.eventDetails.mhao_price,
                  this.eventDetails.mhao_price_vdo,
                  this.eventDetails.mhao_price_both,

                  this.currentFilter
                ) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"PHOTO " + this.eventDetails.mhao_price + " THB":"เหมาๆรูปภาพ " + this.eventDetails.mhao_price + " บาท"}}
            </button>
            <button  v-if=" cart_store_package.cart_videos.length > 0 && this.eventDetails.is_mhao === 'Y' && this.currentFilter ==='video' " class="btn btn-lg btn-primary"
              @click="
                cart_store_package.addToCartALLImage_videos(
                  cart_store_package.cart_videos,
                  this.eventDetails.is_mhao,
                  this.eventDetails.mhao_price,
                  this.eventDetails.mhao_price_vdo,
                  this.eventDetails.mhao_price_both,
                  this.currentFilter
                ),cart_store_package.set_current_filter(this.currentFilter) " style="width: 100%" >
              +<vue-feather type="shopping-cart" stroke-width="2"></vue-feather> {{this.currentLanguage ==='en'?"VIDEO " + this.eventDetails.mhao_price_vdo + " THB":"เหมาๆวิดีโอ " + this.eventDetails.mhao_price_vdo + " บาท"}}
            </button>
            
            
            </span>
            <div v-if="cart_store_package.cart_images.length > 0 && this.eventDetails.is_mhao === 'Y' " class="d-flex justify-content-center" >
              <span style="font-size: small;">{{this.currentLanguage ==='en'?"Note* buy all items per one face searched. or one time searching In the event that you have already purchased additional photos, you can notify the admin for get additional photos: "+fbName:"หมายเหตุ* การเหมา เป็นการเหมาต่อหนึ่งใบหน้าที่ค้นหา กรณีที่เหมาไปแล้ว เจอภาพอื่นๆ เพิ่มเติม(ใบหน้าเดิมที่เหมาไปแล้ว) สามารถแจ้งแอดมินเพื่อส่งรูปเพิ่มเติมให้ได้ทันที Fanpage:  "+ fbName}}</span>
            </div>

            <span v-if="this.eventDetails.is_enable_vdo === 'Y'">
            <div class="row" style="margin: 4px 0;">
              <div class="col-4">
                <button class="btn-sm" :disabled="cart_store_package.cart_images.length > 0 && cart_store_package.cart_videos.length > 0? disabled:''" :style="cart_store_package.cart_images.length > 0 && cart_store_package.cart_videos.length > 0 ? '' : 'background-color: #d4d7d9; border-color: #d4d7d9; color: #6c757d; cursor: not-allowed;'"  
                  :class="['btn', 'btn-lg', 'w-100', currentFilter === 'both' ? 'btn-primary' : 'btn-outline-primary']"
                  @click="setFilter('both')"
                >PHOTO AND VIDEO <span v-if="cart_store_package.cart_images.length > 0 && cart_store_package.cart_videos.length >0">({{ cart_store_package.cart_images.length+cart_store_package.cart_videos.length }})</span></button>
              </div>
              <div class="col-4">
                <button class="btn-sm" :disabled="cart_store_package.cart_images.length <= 0"  :style="cart_store_package.cart_images.length > 0 ? '' : 'background-color: #d4d7d9; border-color: #d4d7d9; color: #6c757d; cursor: not-allowed;'"
                  :class="['btn', 'btn-lg', 'w-100', currentFilter === 'photo' ? 'btn-primary' : 'btn-outline-primary']"
                  @click="setFilter('photo')"
                ><vue-feather type="image" size="13"></vue-feather> PHOTO ({{ cart_store_package.cart_images.length }})</button>
              </div>
              <div class="col-4">
                <button class="btn-sm" :disabled="cart_store_package.cart_videos.length <= 0"  :style="cart_store_package.cart_videos.length > 0 ? '' : 'background-color: #d4d7d9; border-color: #d4d7d9; color: #6c757d; cursor: not-allowed;'"
                  :class="['btn', 'btn-lg', 'w-100', currentFilter === 'video' ? 'btn-primary' : 'btn-outline-primary']"
                  @click="setFilter('video')"
                ><vue-feather type="video" size="13"></vue-feather> VIDEO ({{ cart_store_package.cart_videos.length }})</button>
              </div>
            </div>
            <div id="videoShowing" v-show="currentFilter === 'video' || currentFilter === 'both'"> 
              <div class="masonry-container">
                <div
                  v-for="(src, index) in cart_store_package.cart_videos"
                  :key="index"
                  class="masonry-item"
                >
                  <div class="gallery event masonry-content">
                    <img
                      loading="lazy"
                      :src="src.thumbnail_file_name"
                      :alt="src.original_file_name"
                      @click="() => showVideo(index)"
                      @load="onImageLoad"
                    />

                    <button style="font-size: small;"
                      v-if="
                        src.atc == 'N' &&
                        this.eventDetails.is_free_download === 'Y'
                      "
                      class="btn-free-download"
                      @click="
                        this.download(
                          src.preview_file_name + '?openExternalBrowser=1'
                        ),
                          addToCart()
                      "
                    >
                    Download
                    </button>

                    <button
                      v-if="src.atc == 'N' &&
                        this.eventDetails.is_free_download !== 'Y'
                      "
                      class="btn" style="font-size: small;"
                      @click="
                        cart_store_package.add_cart_video(
                          src.id,
                          src.original_file_name,
                          src.thumbnail_file_name,
                          src.preview_file_name,
                          src.photographer_id,
                          src.event_id,
                          this.currentLanguage
                        ),
                          addToCartVideo()
                      "
                    >
                      +{{this.currentLanguage ==='en'?"Add":"เพิ่ม"}}
                    </button>

                    <button
                      v-if="
                        src.atc == 'Y' &&
                        this.eventDetails.is_free_download !== 'Y'
                      "
                      class="btn-delete" style="font-size: small;"
                      @click="
                        cart_store_package.delete_cart_video(
                          src.id,
                          src.original_file_name,
                          src.thumbnail_file_name,
                          src.photographer_id
                        ),
                          addToCartVideo()
                      "
                    >
                      {{this.currentLanguage ==='en'?"remove":"-ลบ"}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <hr v-if="currentFilter==='both'">
            <div id="imageShowing" v-show="currentFilter === 'photo' || currentFilter === 'both'">
              <div class="masonry-container">
                <div
                  v-for="(src, index) in cart_store_package.cart_images"
                  :key="index"
                  class="masonry-item"
                >
                  <div class="gallery event masonry-content">
                    <img
                      loading="lazy"
                      :src="src.thumbnail_file_name"
                      :alt="src.original_file_name"
                      @click="() => showImg(index)"
                      @load="onImageLoad"
                    />

                    <button style="font-size: small;"
                      v-if="src.atc == 'N' && this.eventDetails.is_free_download === 'Y'"
                      class="btn-free-download"
                      @click="
                        this.download(
                          src.preview_file_name + '?openExternalBrowser=1'
                        ),
                          addToCart()
                      "
                    >
                    Download
                    </button>

                    <button v-if="src.atc == 'N' && this.eventDetails.is_free_download !== 'Y'" class="btn" style="font-size: small;"
                      @click="
                        cart_store_package.add_cart(
                          src.id,
                          src.original_file_name,
                          src.thumbnail_file_name,
                          src.preview_file_name,
                          src.photographer_id,
                          src.event_id,
                          this.currentLanguage
                        ),
                          addToCart()
                      "
                    >
                      +{{this.currentLanguage ==='en'?"Add":"เพิ่ม"}}
                    </button>

                    <button v-if="src.atc == 'Y' && this.eventDetails.is_free_download !== 'Y'" class="btn-delete" style="font-size: small;"
                      @click="
                        cart_store_package.delete_cart(
                          src.id,
                          src.original_file_name,
                          src.thumbnail_file_name,
                          src.photographer_id
                        ),
                          addToCart()
                      "
                    >
                      {{this.currentLanguage ==='en'?"remove":"-ลบ"}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <div v-if="this.isFoundImage !== 'true'" class="d-flex justify-content-center" >
            <div class="card-header">
              <h5>{{this.currentLanguage ==='en'?"Can't find the picture, try changing the picture used to search. Or choose a picture that has only one face in it and is clear, and try again.":"ไม่พบรูป, ลองเปลี่ยนรูปที่ใช้ในการค้นหา หรือเลือกรูปที่มีใบหน้าเพียงคนเดียวในรูป และชัดเจน  แล้วลองอีกครั้ง"}}</h5>
              <p>{{this.currentLanguage ==='en'?"Can't find it? Try asking the admin to help you find it. You can send pictures to":"หาไม่เจอ ลองให้แอดมินช่วยหามั๋ย ส่งรูปมาได้เลยที่"}} <a :href="fbUrl" target="_blank"> {{fbName}}</a></p>
            </div>
          </div>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="this.is_show_image_search==='Y'?lightBoxImages:lightBoxImages_hl"
            @hide="handleHide"
          >

          
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <!-- <button class="close-btn" @click="this.addToCartlb(index)">add+</button>
              <button @click="toolbarMethods.zoomIn">zoom in</button>
            <button @click="toolbarMethods.zoomOut">zoom out</button>
            <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
            <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
            </template>
          </vue-easy-lightbox>

          <!-- Video Lightbox Component -->
          <VideoLightbox
            :visible="videoVisible"
            :videos="cart_store_package.cart_videos"
            :index="videoIndex"
            :current-language="currentLanguage"
            @hide="handleVideoHide"
            @index-change="handleVideoIndexChange"
            @add-to-cart="handleAddVideoToCart"
            @remove-from-cart="handleRemoveVideoFromCart"
          />
        </div>
        <div class="card" v-if="this.is_show_image_search !== 'Y' && this.data_highlight.length>0">
          <b style="text-align: center;padding-bottom: 5px;"> <vue-feather type="bar-chart" size="20"></vue-feather> {{this.currentLanguage ==='en'?"Highlight":"ไฮไลท์ ตัวอย่างภาพกิจกรรม"}}  </b>
          <div v-if="this.loadding_highlight !== 'Y'" class="masonry-container">
            <div
              v-for="(src, index_hl) in this.data_highlight"
              :key="index_hl"
              @click="() => showImg(index_hl)"
              class="masonry-item"
            >
              <div class="gallery_hl event_hl masonry-content">
                <img
                  loading="lazy"
                  :src="src.thumbnail_file_name"
                  :alt="src.original_file_name"
                  @load="onImageLoad"
                />
              </div>
            </div>
          </div>
          <div v-if="this.loadding_highlight === 'Y'"  >
              <div class="d-flex justify-content-center" >
                <img style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
              </div>
          </div>
          <p>&nbsp;</p>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="this.is_show_image_search==='Y'?lightBoxImages:lightBoxImages_hl"
            @hide="handleHide"
          >
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <!-- <button @click="toolbarMethods.zoomIn">zoom in</button>
            <button @click="toolbarMethods.zoomOut">zoom out</button>
            <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
            <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
            </template>
          </vue-easy-lightbox>
        </div>
      </div>
    </div>
  </div>
  <!-- currentFilter: {{ currentFilter }}<br>
  cart_store_package.cart_images: {{ cart_store_package.cart_images }}<br>
  cart_store_package.cart_videos: {{ cart_store_package.cart_videos }} -->
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import VideoLightbox from "../../components/VideoLightbox.vue";

import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";
import { ref } from "vue";
import router from "../../router";
import { useCartStorePackage } from "../../store/modules/cart_package";
//import { useCartStoreVideo } from "../../store/modules/cart_video";
import ManualSearchNote from "../../components/ManualSearchNote.vue";
import axios from "axios";
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
const isBtnaddToCartClick = ref(0);
const isBtnshowImgClick = ref(0);

export default {
  components: {
    VideoLightbox,
    ManualSearchNote
  },
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_TITLE || '',
      description: process.env.VUE_APP_SYSTEM_DESCRIPTION || ``,
      keywords: process.env.VUE_APP_SYSTEM_KEYWORDS ||   ``,
      image:  process.env.VUE_APP_WEBSITE_IMAGE || '',
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })

    
    const cart_store_package = useCartStorePackage();
    cart_store_package.loadFromLocalStorage();

    //const cart_store_video = useCartStoreVideo();
    //cart_store_video.loadFromLocalStorage();
    return { cart_store_package ,/*cart_store_video,*/siteData};
  },

  data() {
    return {
      fbName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || '',
      fbUrl: process.env.VUE_APP_SYSTEM_FACEBOOK_URL || '',
      system_prefix: process.env.VUE_APP_SYSTEM_PREFIX || '',
      isSearching: "false",
      isFoundImage: "true",
      eventDetails: {},
      eventPackage: {},
      eventPackageHybridPackage: {},
      lightBoxImages: [],
      visible: false,
      index: "",
      cart: [],
      imgs_avg_price: 0,
      images_download_all: [],


      lightBoxImages_hl: [],
      index_hl: "",
      visible_hl: false,
      loadding_highlight: "",
      data_highlight: [],
      is_show_image_search: "" ,
      currentLanguage: 'th',
      resizeTimeout: null,
      windowWidth: window.innerWidth,
      layoutTimeout: null,
      uploadProgress: 0,
      isUploading: false,
      
      // Video lightbox properties
      videoVisible: false,
      videoIndex: 0,
      
      // Filter state
      currentFilter: 'both' // 'photo', 'video', 'both'
    };
  },
  
  watch: {
    windowWidth: {
      handler(newWidth, oldWidth) {
        // // Clear any existing timeouts
        // if (this.layoutTimeout) {
        //   clearTimeout(this.layoutTimeout);
        // }
        // if (this.resizeTimeout) {
        //   clearTimeout(this.resizeTimeout);
        // }
        
        // Immediate layout for responsive feedback
        this.layoutMasonryRealtime();
        
        // Precise layout after a short delay
        this.layoutTimeout = setTimeout(() => {
          this.layoutMasonry();
        }, 500);
      },
      immediate: false
    }
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },
  async mounted() {
    this.highlight();
    let _data = await this.getEventDetail(this.$route.params.event_id);
    this.siteData.image = _data.coverurl ;
    this.siteData.title = _data.title +' '+this.siteData.title ;
    this.siteData.description = _data.title +' วันที่ '+_data.event_date_text+' ณ.'+_data.province+' '+this.siteData.description ;
    
    if (this.lightBoxImages.length <= 0) {
      this.lightBoxImages.length = [];
      this.images_download_all = [];
      
      if(this.cart_store_package.cart_images.length > 0 ){
        this.is_show_image_search = "Y"
        this.cart_store_package.cart_images.forEach((item) => {
        
        this.lightBoxImages.push({
          src: item.preview_file_name,
          title:
            "IMAGEID:" +
            this.$route.params.event_id +
            "" +
            item.photographer_id +
            "" +
            item.id,
        });
        this.images_download_all.push(item.preview_file_name);
      });
      this.imgs_avg_price  = (this.eventDetails.mhao_price/this.cart_store_package.cart_images.length).toFixed(2)
      }

    }

    // Setup masonry layout after highlight images load
    this.$nextTick(() => {
      setTimeout(() => {
        this.layoutMasonry();
      }, 500);
    });

    // Listen for window resize with immediate response and reactive update
    window.addEventListener('resize', this.handleResizeReactive, { passive: true });
    
    // Also listen for orientation change on mobile devices
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.windowWidth = window.innerWidth; // Update reactive property
        this.layoutMasonry();
      }, 500);
    });

    // process filter
    if(this.cart_store_package.cart_images.length > 0 && this.cart_store_package.cart_videos.length > 0){
       this.currentFilter = 'both';
    }else if(this.cart_store_package.cart_images.length > 0){
        this.currentFilter = 'photo';
    }else if(this.cart_store_package.cart_videos.length > 0){
        this.currentFilter = 'video';
     }
    
     
  },
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.handleResizeReactive);
    window.removeEventListener('orientationchange', this.handleResize);
    
    // Clear any pending timeouts
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    if (this.layoutTimeout) {
      clearTimeout(this.layoutTimeout);
    }
  },
  methods: {
    async addToCartALLImageAndCreateOrderEventDetail() {
      
      await this.cart_store_package.addToCartALLImageAndCreateOrder(
        this.cart_store_package.cart_images,
        this.eventDetails.is_mhao,
        this.eventDetails.mhao_price,
        this.eventDetails.mhao_price_vdo,
        this.eventDetails.mhao_price_both,
      );

      const req_order = {
          mobile: "auto-create-order",
          email: "auto-create-order",
          event_key: this.eventDetails.event_key,
          amount: 0,
          paid_amount: "0.00",
          imageList: this.cart_store_package.cart,
          image_length: this.cart_store_package.cart.length,
          is_mhao: "N",
          payment_gateway: "GBP",
          payment_channel: "",
          order_team: "",
          coupon_code: "",
          am_order_ref: "",
          is_enable_vdo: "N",
          videoList: [],
          video_length: 0,
        };

        let order_res = await this.cart_store_package.order_creation(req_order);
        if (order_res.status === "success") {
  
          this.cart_store_package.clear_all_cart_in_cart_page();
          if(this.currentLanguage === 'en'){
            await this.cart_store_package.alert_create_order_en(order_res.uuid);
            this.$router.push("/d/" + order_res.uuid);
          }else{
            await this.cart_store_package.alert_create_order(order_res.uuid);
            this.$router.push("/d/" + order_res.uuid);
          }

        } else {
          //console.log("order creation errorx: ", order_res);
          this.cart_store_package.alert_create_order_failed();
        }
      //await this.cart_store_package.createOrder();
      //router.push("/cart");
    },

    async vdoFaceSearch_notuse() {
      try {
        return axios.post("/v2/video/facesearch", {
              search_id: presigned_response.data.search_id,
              file_location: presigned_response.data.file_location,
              event_id: this.eventDetails.event_id,
              event_key: this.$route.params.event_id,
              face_threshold: this.eventDetails.face_threshold,
              mhao_price: this.eventDetails.mhao_price,
              max_face_search: this.eventDetails.max_face_search,
            })
            .then((result_) => {
              
            let result = result_.data;

            if (result.status === "success") {
              if (result.image_length > 0) {
                console.log('result images',result.images);

              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                this.isFoundImage = "false";
              }
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store_package.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;
              
            });
            }  catch (error) {
        // Handle error silently or with user-friendly message
      }

    },
    async highlight() {
      this.loadding_highlight = "Y";
      let data = {
        event_key: this.$route.params.event_id,
      };
      const response = await axios.post("/v1/facesearch/highlight", data);

      if (response.data.status === "success") {
        this.data_highlight = response.data.body;

        this.data_highlight.forEach((item) => {
          this.lightBoxImages_hl.push({
            src: item.preview_file_name,
            title: 'ตัวอย่างภาพความประทับใจ',
          });
        
      });

        this.loadding_highlight = "N";
        
        // Layout masonry after images are loaded with multiple attempts
        this.$nextTick(() => {
          this.layoutMasonryRealtime();          
          // Final attempt after all resources should be loaded
          setTimeout(() => {
            this.layoutMasonry();
          }, 500);
        });
      } else {
        this.loadding_highlight = "N";
        //alert("Load order พบข้อผิดพลาด!");
      }
    },
    async sleep_only() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 10);
      });
    },
    async load_images() {
      let result = await Swal.fire({
        icon: "info",
        title:
          "กรุณาเปิดอนุญาตป๊อปอัป เมื่อเริ่มดาวน์โหลด,  ระบบจะดาวน์โหลดรูปทั้งหมด อัตโนมัติ ",
        html: "<b><u>แนะนำใช้งานผ่านคอมพิวเตอร์หรือระบบแอนดรอยด์</u></b>,<br> บนระบบ ios ระบบจะเปิดแทบเท่ากับจำนวนรูปเพื่อให้กดค้างเพื่อบันทึก <br>คุณต้องการดาวน์โหลดรูปทั้งหมดใช่หรือไม่?",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#7991a8",
        confirmButtonText: "เริ่มดาวน์โหลด",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          let count = 0;
          while (count < this.images_download_all.length) {
            window.open(
              this.images_download_all[count] + "?openExternalBrowser=1",
              "_blank"
            );
            this.sleep_only();
            count++;
          }
        } else {
          return false;
        }
      });
    },
    async download(url) {
      window.open(url, "_blank");
    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackageHybridPackage = res.data.package_hb_package;
        this.eventDetails.is_mhao = 'N'
        this.eventDetails.is_enable_vdo = 'N'

        if(this.eventDetails.is_mhao==='N'){
          localStorage.setItem('_is_mhao_flag','NO')
          this.cart_store_package.is_mhao_flag = 'NO'
          
        }

        let consent_check = localStorage.getItem(
          "consent_" + this.$route.params.event_id
        );
        if (consent_check !== "true") {
          if(this.currentLanguage === 'en'){
            let result = await this.cart_store_package.alert_policy_consent_en();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );
                if(this.eventDetails.is_hybrid === 'Y'){
                    const result = await Swal.fire({
                      title: this.currentLanguage === 'en' ? 'Hybrid Event' : 'กิจกรรม Hybrid',
                      html: this.currentLanguage === 'en' 
                        ? `<div style="text-align: left;">
                            <p>This is a <strong>Hybrid Event</strong> where athletes can choose:</p>
                            <ul>
                        <li><strong><i class="fa fa-hashtag"></i> Multiple Package:</strong> Search multiple faces, combine them, and purchase at package price</li>
                        <li><strong><i class="fa fa-hashtag"></i> Special Unlimited Package:</strong> 1 face, unlimited photos at a special flat rate</li>
                            </ul>
                            <p>Please select your preferred option below:</p>
                          </div>`
                        : `<div style="text-align: left;">
                            <p>กิจกรรมนี้เป็น <strong>กิจกรรมการซื้อภาพแบบไฮบริด</strong> โดยที่นักกีฬาสามารถเลือกได้ว่า:</p>
                            <ul>
                        <li><strong><i class="fa fa-hashtag"></i>ซื้อราคาแพ็คเกจ:</strong> สามารถค้นหา และซื้อพร้อมกัน หลายๆ ใบหน้า ในราคาแพ็คเกจ</li>
                        <li><strong><i class="fa fa-hashtag"></i>ซื้อโปรเหมาๆ:</strong> 1 ใบหน้า ไม่จำกัดจำนวนภาพ ในราคาเหมาๆ สุดคุ้ม</li>
                            </ul>
                          </div>`,
                      
                    
                      showDenyButton: true,
                      confirmButtonText: this.currentLanguage === 'en' 
                        ? '<i class="fa fa-hashtag"></i> Package' 
                        : '<i class="fa fa-hashtag"></i> ซื้อราคาแพ็คเกจ',
                      denyButtonText: this.currentLanguage === 'en' 
                        ? '<i class="fa fa-hashtag"></i> Unlimited Package' 
                        : '<i class="fa fa-hashtag"></i> ซื้อโปรเหมาๆ (สุดคุ้ม)',
                      confirmButtonColor: '#3085d6',
                      denyButtonColor: '#28a745',
                      cancelButtonColor: '#6c757d',
                      allowOutsideClick: false,
                      customClass: {
                        popup: 'swal-wide'
                      }
                          });

                          if (result.isConfirmed) {
                      // Stay on current page - do nothing
                          } else if (result.isDenied) {
                      // Open wholesale page in new tab
                      window.open(this.$route.params.event_id + '/wholesale', '_blank');
                          }
                    
                  }



            } else {
              router.push({ path: "/" });
            }
          }else{
            let result = await this.cart_store_package.alert_policy_consent();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );

              if(this.eventDetails.is_hybrid === 'Y'){
                    const result = await Swal.fire({
                      title: this.currentLanguage === 'en' ? 'Hybrid Event' : 'กิจกรรม Hybrid',
                      html: this.currentLanguage === 'en' 
                        ? `<div style="text-align: left;">
                            <p>This is a <strong>Hybrid Event</strong> where athletes can choose:</p>
                            <ul>
                        <li><strong><i class="fa fa-hashtag"></i> Multiple Package:</strong> Search multiple faces, combine them, and purchase at package price</li>
                        <li><strong><i class="fa fa-hashtag"></i> Special Unlimited Package:</strong> 1 face, unlimited photos at a special flat rate</li>
                            </ul>
                            <p>Please select your preferred option below:</p>
                          </div>`
                        : `<div style="text-align: left;">
                            <p>กิจกรรมนี้เป็น <strong>กิจกรรมการซื้อภาพแบบไฮบริด</strong> โดยที่นักกีฬาสามารถเลือกได้ว่า:</p>
                            <ul>
                        <li><strong><i class="fa fa-hashtag"></i>ซื้อราคาแพ็คเกจ:</strong> สามารถค้นหา และซื้อพร้อมกัน หลายๆ ใบหน้า ในราคาแพ็คเกจ</li>
                        <li><strong><i class="fa fa-hashtag"></i>ซื้อโปรเหมาๆ:</strong> 1 ใบหน้า ไม่จำกัดจำนวนภาพ ในราคาเหมาๆ สุดคุ้ม</li>
                            </ul>
                          </div>`,
                      
                    
                      showDenyButton: true,
                      confirmButtonText: this.currentLanguage === 'en' 
                        ? '<i class="fa fa-hashtag"></i> Package' 
                        : '<i class="fa fa-hashtag"></i> ซื้อราคาแพ็คเกจ',
                      denyButtonText: this.currentLanguage === 'en' 
                        ? '<i class="fa fa-hashtag"></i> Unlimited Package' 
                        : '<i class="fa fa-hashtag"></i> ซื้อโปรเหมาๆ (สุดคุ้ม)',
                      confirmButtonColor: '#3085d6',
                      denyButtonColor: '#28a745',
                      cancelButtonColor: '#6c757d',
                      allowOutsideClick: false,
                      customClass: {
                        popup: 'swal-wide'
                      }
                          });

                          if (result.isConfirmed) {
                      // Stay on current page - do nothing
                          } else if (result.isDenied) {
                      // Open wholesale page in new tab
                      window.open(this.$route.params.event_id + '/wholesale', '_blank');
                          }
                    
                  }
            } else {
              router.push({ path: "/" });
            }
          }
          

        }
        return res.data;
      } else {
        //alert("พบข้อผิดพลาด! ไม่พบ url ของกิจกรรม");
        router.push({ path: "/404" });
      }
    },
    addToCart() {
      isBtnaddToCartClick.value = 1;
    },
    addToCartVideo() {
      isBtnaddToCartClick.value = 1;
    },
    addAllImageToCart() {
      //router.push({ path: "cart" });
    },
    showImg(index) {
      isBtnshowImgClick.value = 1;

      if (isBtnaddToCartClick.value === 0) {
        this.index = index;
        this.visible = true;
      }
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    
    showVideo(index) {
      this.videoIndex = index;
      this.videoVisible = true;
    },
    
    handleVideoHide() {
      this.videoVisible = false;
    },
    
    handleVideoIndexChange(newIndex) {
      this.videoIndex = newIndex;
    },
    
    setFilter(filterType) {
      this.currentFilter = filterType;
      this.$nextTick(() => {
        setTimeout(() => { this.layoutMasonry(); }, 50);
      });
    },
    
    handleAddVideoToCart(payload) {
      const { video, index } = payload;
      this.cart_store_package.add_cart_video(
        video.id,
        video.original_file_name,
        video.thumbnail_file_name,
        video.preview_file_name,
        video.photographer_id,
        video.event_id,
        this.currentLanguage
      );
    },
    
    handleRemoveVideoFromCart(payload) {
      const { video, index } = payload;
      this.cart_store_package.delete_cart_video(
        video.id,
        video.original_file_name,
        video.thumbnail_file_name,
        video.photographer_id
      );
    },
    handleHide() {
      this.visible = false;
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    faceSearch() {
      if(this.eventDetails.is_mhao === 'Y'){
        
        if(this.cart_store_package.cart.length > 0 || this.cart_store_package.cart_vdo.length > 0){
            if(confirm(this.currentLanguage==='en'?"You have photos or videos in your shopping cart. If you search again The pictures in the basket will be Automatically deleted Do you want to continue the transaction?":"ท่านมีรูปที่ทำรายการค้างอยู่ในตะกร้า ถ้าหากค้นหาใหม่อีกครั้ง รูปที่อยู่ในตะกร้าจะถูก ลบออกโดยอัตโนมัติ  ต้องการทำรายการต่อใช่หรือไม่?")){
              this.cart_store_package.clear_cart(this.eventDetails.is_mhao);
              this.cart_store_package.clear_cart_video(this.eventDetails.is_mhao);
              this.faceSearchV3_action();
            }else{
              document.getElementById("fileInput").value = null;
            }
          }else{ 
            this.faceSearchV3_action();
          }
        // if(this.eventDetails.is_enable_vdo==='Y'){

        //   if(this.cart_store_package.cart.length > 0 || this.cart_store_package.cart_vdo.length > 0){
        //     if(confirm(this.currentLanguage==='en'?"You have photos or videos in your shopping cart. If you search again The pictures in the basket will be Automatically deleted Do you want to continue the transaction?":"ท่านมีรูปที่ทำรายการค้างอยู่ในตะกร้า ถ้าหากค้นหาใหม่อีกครั้ง รูปที่อยู่ในตะกร้าจะถูก ลบออกโดยอัตโนมัติ  ต้องการทำรายการต่อใช่หรือไม่?")){
        //       this.cart_store_package.clear_cart(this.eventDetails.is_mhao);
        //       this.cart_store_package.clear_cart_video(this.eventDetails.is_mhao);
        //       this.faceSearchV3_action();
        //     }else{
        //       document.getElementById("fileInput").value = null;
        //     }
        //   }else{ 
        //     this.faceSearchV3_action();
        //   }

        // }else{
        //   if(this.cart_store_package.cart.length > 0){
        //     if(confirm(this.currentLanguage==='en'?"You have photos in your shopping cart. If you search again The pictures in the basket will be Automatically deleted Do you want to continue the transaction?":"ท่านมีรูปที่ทำรายการค้างอยู่ในตะกร้า ถ้าหากค้นหาใหม่อีกครั้ง รูปที่อยู่ในตะกร้าจะถูก ลบออกโดยอัตโนมัติ  ต้องการทำรายการต่อใช่หรือไม่?")){
        //       this.cart_store_package.clear_cart(this.eventDetails.is_mhao)
        //       this.cart_store_package.clear_cart_video(this.eventDetails.is_mhao);
        //       this.faceSearchV3_action();
        //     }else{
        //       document.getElementById("fileInput").value = null;
        //     }
        //   }else{ 
        //     this.faceSearchV3_action();
        //   }
        // }


      }else{
        if(this.cart_store_package.cart_vdo.length > 0){
          this.cart_store_package.clear_cart_video(this.eventDetails.is_mhao);
          this.faceSearchV3_action();
        }else{
          this.faceSearchV3_action();
        }
        
      }

        

      
    },
    faceSearch_action(){
      if (document.getElementById("fileInput").value != "") {
        var file_size = fileInput.files[0].size / 1000000;
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
          this.lightBoxImages = [];
        this.isSearching = "true";
        this.is_show_image_search = "Y"
        this.isFoundImage = "true";
        this.cartcart_store_package_store.clear_cart_images();
        this.cartcart_store_package_store.clear_cart_latest();
        this.imgs_avg_price = 0;
        document.getElementById("fileInput").disabled = true;
        var formdata = new FormData();
        //var requestOptions = {
        //  method: "POST",
        //  body: formdata,
        //  redirect: "follow",
        //};
        formdata.append("file", fileInput.files[0], fileInput.files[0].name);
        formdata.append("event_id", this.eventDetails.event_id);
        formdata.append("event_key", this.$route.params.event_id);
        formdata.append("face_threshold", this.eventDetails.face_threshold);
        formdata.append("mhao_price", this.eventDetails.mhao_price);
        formdata.append("max_face_search", this.eventDetails.max_face_search);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          process.env.VUE_APP_RUNNING_API + "/v1/facesearch",
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            result = JSON.parse(result);

            if (result.status === "success") {
              if (result.image_length > 0) {
                this.isFoundImage = "true";
                this.cart_store_package.cart_images = result.images;

                if(this.eventDetails.is_mhao === 'Y'){
                  this.cart_store_package.cart_latest = result.images;
                }
                localStorage.setItem('cart_latest', JSON.stringify(this.cart_store_package.cart_latest))

                this.imgs_avg_price = result.avg_price;
                this.cart_store_package.cart_images.forEach((item) => {
                  //this.lightBoxImages.push(item.preview_file_name);
                  this.lightBoxImages.push({
                    src: item.preview_file_name,
                    title:
                      this.$route.params.event_id +
                      ":" +
                      this.system_prefix +
                      item.photographer_id +
                      "-" +
                      "IMAGEID:" +
                      item.id,
                  });
                  this.images_download_all.push(item.preview_file_name);
                });
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                //alert("ไม่พบรรูปที่ตรงกัน");
                this.isFoundImage = "false";
              }
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store_package.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;
          })
          .catch((error) => {
            // Handle error silently or with user-friendly message
          });
          
        }else{
          this.cart_store_package.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
        
      
        
      }

    },
    async faceSearchV2_action_notuse(){
      if (document.getElementById("fileInput").value != "") {
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
              this.lightBoxImages = [];
        this.lightBoxVideos = [];
        this.isSearching = "true";
        this.isUploading = true;
        this.uploadProgress = 0;
        this.is_show_image_search = "Y"
        this.isFoundImage = "true";
        this.cart_store_package.clear_cart_images();
        this.cart_store_package.clear_cart_latest();
        this.imgs_avg_price = 0;
        document.getElementById("fileInput").disabled = true;


        return axios.post("/v2/photo/facesearch/sign", {
          event_key: this.$route.params.event_id,
          file_name: fileInput.files[0].name,
          file_type: "image/jpg"
        },)
        .then((presigned_response) => {
          return axios.put(presigned_response.data.url, fileInput.files[0], {
            headers: {
              "Content-Type": "image/jpg",
              "Content-Disposition": `inline; filename="${presigned_response.data.file_name}"`,
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          })
          .then((put_response) => {
            if(put_response.status === 200){
              // Upload completed, hide upload progress and show search progress
              this.isUploading = false;
              this.uploadProgress = 0;
              
             
              return axios.post("/v2/photo/facesearch", {
              search_id: presigned_response.data.search_id,
              file_location: presigned_response.data.file_location,
              event_id: this.eventDetails.event_id,
              event_key: this.$route.params.event_id,
              face_threshold: this.eventDetails.face_threshold,
              mhao_price: this.eventDetails.mhao_price,
              max_face_search: this.eventDetails.max_face_search,
            })
            .then((result_) => {
            
            let result = result_.data;

            if (result.status === "success") {
              if (result.image_length > 0) {
                this.isFoundImage = "true";
                this.cart_store_package.cart_images = result.images;

                if(this.eventDetails.is_mhao === 'Y'){
                  this.cart_store_package.cart_latest = result.images;
                }
                localStorage.setItem('cart_latest', JSON.stringify(this.cart_store_package.cart_latest))

                this.imgs_avg_price = result.avg_price;
                this.cart_store_package.cart_images.forEach((item) => {
                  this.lightBoxImages.push({
                    src: item.preview_file_name,
                    title:
                      this.$route.params.event_id +
                      ":" +
                      this.system_prefix +
                      item.photographer_id +
                      "-" +
                      "IMAGEID:" +
                      item.id,
                  });
                  this.images_download_all.push(item.preview_file_name);
                });
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                this.isFoundImage = "false";
              }
              
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store_package.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;
              
            }).then(() => {

              //alert("is_enable_vdo: "+this.eventDetails.is_enable_vdo)
              
              if(this.eventDetails.is_enable_vdo==='Y'){
                // Proceed with video face search
                return axios.post("/v2/video/facesearch", {
                      search_id: presigned_response.data.search_id,
                      file_location: presigned_response.data.file_location,
                      event_id: this.eventDetails.event_id,
                      event_key: this.$route.params.event_id,
                      face_threshold: this.eventDetails.face_threshold,
                      mhao_price: this.eventDetails.mhao_price,
                      max_face_search: this.eventDetails.max_face_search,
                    })
                    .then((result_) => {
                      
                    let result = result_.data;

                    if (result.status === "success") {
                      //console.log('video face search result size: '+result.image_length);
                      if (result.image_length > 0) {

                        //this.isFoundImage = "true";
                        //console.log('result video',result.images);
                        this.cart_store_package.cart_videos = result.images;

                      } else {
                        this.isSearching = "false";
                        document.getElementById("fileInput").disabled = false;
                        this.isFoundImage = "false";
                      }
                    } else {
                      this.isSearching = "false";
                      this.isFoundImage = "false";
                      document.getElementById("fileInput").disabled = false;
                      this.cart_store_package.alert_commomd_message_info(
                        "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
                      );
                    }
                    document.getElementById("fileInput").value = null;
                      
                    });
              }});
            }    
          })
          .catch((error) => {
            // Reset progress and search state on error
            this.isSearching = "false";
            this.isUploading = false;
            this.uploadProgress = 0;
            this.isFoundImage = "false";
            document.getElementById("fileInput").disabled = false;
            document.getElementById("fileInput").value = null;
            this.cart_store_package.alert_commomd_message_info(
              "พบข้อผิดพลาดจากการอัปโหลดหรือค้นหา กรุณาลองอีกครั้ง"
            );
          });
        });
          
        }else{
          this.cart_store_package.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
      }

    },
    async faceSearchV3_action(){
      if (document.getElementById("fileInput").value != "") {
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
          this.lightBoxImages = [];
          this.lightBoxVideos = [];
          this.isSearching = "true";
          this.isUploading = true;
          this.uploadProgress = 0;
          this.is_show_image_search = "Y"
          this.isFoundImage = "true";
          this.cart_store_package.clear_cart_images();
          this.cart_store_package.clear_cart_images();
          this.cart_store_package.clear_cart_videos();
          this.imgs_avg_price = 0;
          this.currentFilter = 'both';
          document.getElementById("fileInput").disabled = true;

          try {
            // Step 1: Get presigned URL
            const presigned_response = await axios.post("/v2/photo/facesearch/sign", {
              event_key: this.$route.params.event_id,
              file_name: fileInput.files[0].name,
              file_type: "image/jpg"
            });

            // Step 2: Upload file
            const put_response = await axios.put(presigned_response.data.url, fileInput.files[0], {
              headers: {
                "Content-Type": "image/jpg",
                "Content-Disposition": `inline; filename="${presigned_response.data.file_name}"`,
              },
              onUploadProgress: (progressEvent) => {
                this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            });

            if(put_response.status === 200){
              // Upload completed
              this.isUploading = false;
              this.uploadProgress = 0;

              const searchParams = {
                search_id: presigned_response.data.search_id,
                file_location: presigned_response.data.file_location,
                event_id: this.eventDetails.event_id,
                event_key: this.$route.params.event_id,
                face_threshold: this.eventDetails.face_threshold,
                mhao_price: this.eventDetails.mhao_price,
                max_face_search: this.eventDetails.max_face_search,
              };

              // Step 3: Run photo and video search in parallel
              const promises = [
                axios.post("/v2/photo/facesearch", searchParams)
              ];

              if(this.eventDetails.is_enable_vdo === 'Y'){
                promises.push(axios.post("/v2/video/facesearch", searchParams));
              }

              const results = await Promise.allSettled(promises);

              // Handle photo search result
              const photoResult = results[0];
              if (photoResult.status === 'fulfilled' && photoResult.value.data.status === "success") {
                const result = photoResult.value.data;
                if (result.image_length > 0) {
                  this.isFoundImage = "true";
                  this.cart_store_package.cart_images = result.images;

                  if(this.eventDetails.is_mhao === 'Y'){
                    this.cart_store_package.cart_latest = result.images;
                  }
                  localStorage.setItem('cart_latest', JSON.stringify(this.cart_store_package.cart_latest));

                  this.imgs_avg_price = result.avg_price;
                  this.cart_store_package.cart_images.forEach((item) => {
                    this.lightBoxImages.push({
                      src: item.preview_file_name,
                      title: this.$route.params.event_id + ":" + this.system_prefix + item.photographer_id + "-" + "IMAGEID:" + item.id,
                    });
                    this.images_download_all.push(item.preview_file_name);
                  });
                } else {
                  this.isFoundImage = "false";
                }
              } else {
                this.cart_store_package.alert_commomd_message_info("พบข้อผิดพลาดจากการค้นหารูปภาพ");
              }

              // Handle video search result
              if(this.eventDetails.is_enable_vdo === 'Y' && results[1]) {
                const videoResult = results[1];
                if (videoResult.status === 'fulfilled' && videoResult.value.data.status === "success") {
                  const result = videoResult.value.data;
                  //console.log('video face search result size: ' + result.image_length);
                  if (result.image_length > 0) {
                    this.isFoundImage = "true";
                    //console.log('result video', result.images);
                    this.cart_store_package.cart_videos = result.images;
                  }
                }
              }

              this.isSearching = "false";
              document.getElementById("fileInput").disabled = false;
              document.getElementById("fileInput").value = null;

              // process filter
              if(this.cart_store_package.cart_images.length > 0 && this.cart_store_package.cart_videos.length > 0){
                this.currentFilter = 'both';
              }else if(this.cart_store_package.cart_images.length > 0){
                this.currentFilter = 'photo';
              }else if(this.cart_store_package.cart_videos.length > 0){
                this.currentFilter = 'video';
              }

              this.$nextTick(() => {
                setTimeout(() => { this.layoutMasonry(); }, 100);
              });
            }
          } catch (error) {
            // Reset progress and search state on error
            this.isSearching = "false";
            this.isUploading = false;
            this.uploadProgress = 0;
            this.isFoundImage = "false";
            document.getElementById("fileInput").disabled = false;
            document.getElementById("fileInput").value = null;
            this.cart_store_package.alert_commomd_message_info("พบข้อผิดพลาดจากการอัปโหลดหรือค้นหา กรุณาลองอีกครั้ง");
          }
        } else {
          this.cart_store_package.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
      }
    },
    addToCartlb(_image_id){
      // Handle add to cart from lightbox
    },
    onImageLoad(event) {
      // Re-layout masonry when images load with immediate response
      this.layoutMasonryRealtime();
      
      // Follow up with precise layout
      this.$nextTick(() => {
        setTimeout(() => {
          this.layoutMasonry();
        }, 10);
      });
    },
    
    handleResize() {
      // Update window width to trigger watcher
      this.windowWidth = window.innerWidth;
      
      // Clear any pending timeout
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      
      // Immediate real-time layout adjustment
      this.layoutMasonryRealtime();
      
      // Additional precise layout after a short delay for final positioning
      this.resizeTimeout = setTimeout(() => {
        this.layoutMasonry();
      }, 10);
    },
    
    handleResizeReactive() {
      // Update window width to trigger Vue watcher
      this.windowWidth = window.innerWidth;
      
      // The rest will be handled by the watcher
    },
    
    layoutMasonryRealtime() {
      this.layoutMasonry(true);
    },
    
    layoutMasonry(realtime = false) {
      document.querySelectorAll('.masonry-container').forEach(container => {
        if (container.offsetWidth === 0) return; // skip hidden containers (v-show)
        this._layoutContainer(container, realtime);
      });
    },

    _layoutContainer(container, realtime = false) {
      const items = container.querySelectorAll('.masonry-item');
      if (items.length === 0) return;
      
      const gap = 5;
      const columns = this.getMasonryColumns();
      const columnHeights = new Array(columns).fill(0);
      
      const containerWidth = container.offsetWidth;
      const availableWidth = containerWidth - (gap * (columns - 1));
      const finalItemWidth = Math.max(80, Math.floor(availableWidth / columns));
      
      document.documentElement.style.setProperty('--masonry-item-width', `${finalItemWidth}px`);
      document.documentElement.style.setProperty('--masonry-columns', columns);
      
      items.forEach((item) => {
        item.style.width = `${finalItemWidth}px`;
        item.style.maxWidth = `${finalItemWidth}px`;

        if (realtime) {
          item.style.display = 'block';
          item.style.visibility = 'visible';
        }
        
        const img = item.querySelector('img');
        if (img) {
          img.style.width = '100%';
          img.style.height = 'auto';
          img.style.display = 'block';
          img.style.maxWidth = `${finalItemWidth}px`;
          
          const imageReady = realtime
            ? img.naturalWidth > 0 && img.naturalHeight > 0
            : img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;

          if (imageReady) {
            const aspectRatio = img.naturalHeight / img.naturalWidth;
            const calculatedHeight = finalItemWidth * aspectRatio;
            const maxAllowedHeight = Math.min(calculatedHeight, window.innerHeight * 0.9);
            img.style.maxHeight = `${maxAllowedHeight}px`;
            img.style.minHeight = `${Math.min(calculatedHeight, maxAllowedHeight)}px`;
          }
        }
        
        item.offsetHeight; // Force reflow
        
        this.positionMasonryItem(item, columnHeights, gap, finalItemWidth, realtime);
      });
      
      container.style.height = `${Math.max(...columnHeights)}px`;
    },
    
    positionMasonryItem(item, columnHeights, gap, itemWidth, realtime = false) {
      const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
      const x = shortestColumnIndex * (itemWidth + gap);
      const y = columnHeights[shortestColumnIndex];
      
      item.style.position = 'absolute';
      item.style.left = `${x}px`;
      item.style.top = `${y}px`;
      
      const itemHeight = realtime ? (item.offsetHeight || 200) : item.offsetHeight;
      columnHeights[shortestColumnIndex] += itemHeight + gap;
    },
    getMasonryColumns() {
      const width = this.windowWidth || window.innerWidth;
      
      let columns;
      if (width < 480) columns = 2;           // Mobile portrait
      else if (width < 768) columns = 3;      // Mobile landscape / Small tablet
      else if (width < 1024) columns = 4;     // Tablet
      else if (width < 1550) columns = 5;     // Desktop
      else columns = 6;                       // Large desktop
      
      return columns;
    }
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  display: none;
}

div.gallery:hover {
  cursor: pointer;
  opacity: 0.9;
}

div.gallery_hl:hover {
  cursor: pointer;
  opacity: 0.7;
}

@media screen and (min-width: 851px) and (max-width: 9000px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 229px;
    min-width: auto;
    max-width: 346px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 231.66px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 346px;
  }
}

@media screen and (min-width: 451px) and (max-width: 850px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 225px;
    min-width: auto;
    max-width: 340px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 225.96px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 340px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gallery {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 1px;
    /* border: 1px solid #ccc; */
    box-shadow: 4px -10px 35px -30px rgba(0,0,0,0.57);
  }

  div.gallery img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }

  div.gallery_hl {
    width: 49%;
    float: left;
    margin: 1px;
    /* padding: 1px;
    border: 1px solid #ccc; */
    box-shadow: 4px -10px 35px -30px rgba(0,0,0,0.57);
  }

  div.gallery_hl img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.drop-container {
  position: relative;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
  padding: 20px;
  border-radius: 10px;
  border: 1px dashed #000000;
  cursor: pointer;
  transition: background 0.2s ease-in-out, border 0.2s ease-in-out;
}
.drop-container {
  background: #99989846;
}
.drop-container:hover {
  background: #979696ad;
}
/* 
.drop-container:hover .drop-title {
  color: #222;
} */

.drop-title {
  color: #444;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  transition: color 0.2s ease-in-out;
}

input[type="file"] {
  display: none;
}

/* Progress Bar Styles */
.progress-container {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #0486d6, #00a8ff);
  border-radius: 4px;
  transition: width 0.3s ease;
  min-width: 2px;
}

.event {
  position: relative;
  width: auto;
  height: auto;
}

.event img {
  height: auto;
  width: auto;
}

.event .btn {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}
.event .btn-free-download {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 5px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete-go-to-cart {
  position: absolute;
  top: 10%;
  left: 80%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 3px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event_hl {
  position: relative;
  width: auto;
  height: auto;
}

.event_hl img {
  height: auto;
  width: auto;
}

/* When .gallery is inside masonry, let JS control the height (same as gallery_hl) */
.masonry-container .gallery {
  max-height: none;
  min-height: auto;
  float: none;
  width: 100%;
  margin: 0;
}

.masonry-container .gallery img {
  max-height: none !important;
  min-height: auto !important;
  width: 100% !important;
  height: auto !important;
  display: block;
}

/* Masonry Gallery Styles */
.masonry-container {
  position: relative;
  width: 100%; /* Use full width available */
  margin: 5px auto;
  /* transition: height 0.2s ease-out; */
}

.masonry-item {
  margin-bottom: 8px;
  break-inside: avoid;
  box-sizing: border-box;
  min-width: 0;
  /* transition: left 0.15s ease-out, top 0.15s ease-out, width 0.15s ease-out; */
}

.masonry-item:hover {
  z-index: 1;
}

.masonry-content {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
}

.masonry-content:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
}

.masonry-content img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 2px;
  max-width: 100%;
  max-height: 90vh; /* Allow more height */
  object-fit: cover; /* Changed back to cover for better space usage */
  transition: transform 0.2s ease-out;
}

/* Dynamic responsive sizing using CSS custom properties */
:root {
  --masonry-item-width: 200px;
  --masonry-columns: 5;
}

/* Responsive masonry columns - dynamic width calculation */
@media screen and (min-width: 1400px) {
  :root {
    --masonry-columns: 6;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1399px) {
  :root {
    --masonry-columns: 5;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  :root {
    --masonry-columns: 4;
  }
}

@media screen and (min-width: 480px) and (max-width: 767px) {
  :root {
    --masonry-columns: 3;
  }
}

@media screen and (max-width: 479px) {
  :root {
    --masonry-columns: 2;
  }
}

/* Force image dimensions to fill container completely */
.masonry-item img {
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  max-height: 90vh !important; /* Allow more vertical space */
  display: block !important;
  border-radius: 2px;
  object-fit: cover !important; /* Fill space completely */
}

/* Override old gallery_hl styles for masonry */
.masonry-container .gallery_hl {
  margin: 0;
  float: none;
  width: 100%;
  height: auto;
  min-height: auto;
  max-height: none;
  min-width: auto;
  max-width: none;
  overflow: hidden;
}

.masonry-container .gallery_hl img {
  width: 100% !important;
  height: auto !important;
  padding: 0;
  min-height: auto;
  max-height: 90vh !important; /* Allow more vertical space */
  min-width: auto;
  max-width: 100% !important;
  object-fit: cover !important; /* Fill space completely */
}
/*
.event .btn:hover {
  background-color: black;
}
.event .btn-delete:hover {
  background-color: black;
}
*/
</style>
    
